/*
 * UNIVERSIDAD AUTONOMA DE AGUASCALIENTES
 * DIRECCION GENERAL DE PLANEACION Y DESARROLLO
 * DEPARTAMENTO DE SISTEMAS (OPTIMIZACION DE PROYECTOS ADMINISTRATIVOS - OPA)
 *
 * PROYECTO:  COMPRAS
 * PROPOSITO: Subir las cotizaciones de los procedimientos que participa un proveedor logeado.
 *
 * AUTOR:     FZALDIVAR
 * FECHA:     04/Nov/2019
 *
*/
import { Component, OnInit, Output, Input, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ApiProcedimientosService } from '../../../../../services/api-procedimientos.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiRegistryService } from 'src/app/services/api-registry.service';
import { ApiDownloadFileService } from 'src/app/services/api-download-file.service';
import { ApiAuthService } from 'src/app/services/api-auth.service';
import { Proveedor } from 'src/app/models/Proveedor';
import { isNullOrUndefined } from 'util';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ApiUploadFileService } from 'src/app/services/api-upload-file.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

declare var $: any;

@Component({
  selector: 'subirCotizacion-producto',
  templateUrl: './subirCotizacion-producto.component.html',
  styleUrls: ['./subirCotizacion-producto.component.css']
})
export class SubirCotizacionProductoComponent implements OnInit {
  public datosGrales: any[] = [];
  public articulos: any[] = [];

  public anexos: any[] = [];

  /* ****/
  public vpnMov;
  public vpsTipoProv;
  public vpsCveDoc;
  @ViewChild('myInput', {static: false}) myInput: ElementRef;
  vpnGoddocs: string = '';
  pk_proveedor: string = '';
  comentarios: string = '';
  public mensajeAlerta: string = '';
  public mensajeExito: string = '';
  public tipoAlerta: number;
  public tipoMov: number = 0;
  /**** */
  public countPartipa: number = 0;
  public frmPartidas: FormGroup;
  public files: FileList;
  public validaEnvio = false;
  public errfechaCotiza = false;

  public mensajeError: string = '¡Error!';
  public error: number;

  @Input() public anio: string;
  @Input() public idProc: string;
  @Output() EventoMenu = new EventEmitter();
  @ViewChild('myInputFile', {static: false}) myInputFile: ElementRef;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  private KeysFiles: {
    idRow: number,
    anio: string,
    idProcedimiento: string,
    idPartida: string,
    idProveedor: string,
    FolioGodocs: string,
    nombre_file: string
  }

  constructor(private apiProcedimientos: ApiProcedimientosService, private apiRegistry: ApiRegistryService,
              private apiDownload: ApiDownloadFileService, private router: Router, private apiAuth: ApiAuthService,
              private formBuilder: FormBuilder, private apiUpload: ApiUploadFileService) { }

  ngOnInit() {
    $('#mod_procesando').modal('show');
    this.readDatosGrales(this.anio, this.idProc);
  }

  readDatosGrales(anio: string, idProcedimiento: string) {
    let proveedor;
    let prov: Proveedor = this.getProveedor();
    //$('#texto_error').text('Ocurrió un error al mostrar la información del procedimiento.');

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}' && data[0].info !== '[]'){
        proveedor = JSON.parse(data[0].info);

        this.apiProcedimientos.getDatosGralesProv(anio, idProcedimiento, proveedor[0].PK_FKCPRCO).subscribe(data => {
          if(data[0].success){
            this.datosGrales = JSON.parse(data[0].info);
            //console.log("Datos Generales", this.datosGrales);

            this.readArticulos(anio, idProcedimiento, proveedor[0].PK_FKCPRCO);
          } else {
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
            }, 500);
          }
        },
        error => {
          this.error = error.status;
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
          }, 500);
        });
      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  readArticulos(anio: string, idProcedimiento: string, proveedor: string) {
    this.apiProcedimientos.getArticulosProv(anio, idProcedimiento, proveedor).subscribe(data => {
      if(data[0].success){
        this.articulos = JSON.parse(data[0].info);
        //console.log("Articulos", this.articulos);

        /*Actualizar campo de Fecha de vigencia*/
        let fechaCotiza;
        let fechaActual = new Date();

        for (let i=0; i<=this.articulos.length-1; i++){
          if (this.articulos[i].FECHAVIGENCIA !== ''){
            fechaCotiza = this.articulos[i].FECHAVIGENCIA;
          }
        }

        if (fechaCotiza==''){
          this.errfechaCotiza = true;
        }

        $(document).ready(function () {
          $('#txt_fecha_cotiza').datepicker({
              uiLibrary: 'bootstrap4',
              iconsLibrary: 'fontawesome',
              format: 'dd/mm/yyyy',
              value: fechaCotiza,
              minDate: fechaActual
            });
        });

        /*** Inicialización de FormBuilderArray y llenado de datos. ***/
        this.frmPartidas = this.formBuilder.group({
          partidasDetails: this.formBuilder.array([])
        });

        const control = <FormArray>this.frmPartidas.controls['partidasDetails'];
        let j=0;

        if (this.articulos.length > 0) {
          this.articulos.forEach(x => {

            control.push(this.initPartidas(proveedor, x));

            /*Si el row tiene un ID quiere decir que ya particpa ahi y suma en el contador de participaciones. */
            if (x.FKDPPPR_PK_CONSEC !==''){
              this.countPartipa = this.countPartipa + 1;
            }

            /*Deshabilita los campos que estaran ocultos para que no se consideren en las validaciones de captura.*/
            this.disabledFields(j);
            j++;
          });
        } else {
          control.push(this.initPartidas(proveedor, null));
        }
        /***************************************/

        $(document).ready(function () {
          let tbl_partidas = $('#tbl_partidas').DataTable({
            //dom: '<"row">ltp',
            //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ],
            ordering: true,
            order: [],
            columnDefs: [{
              orderable: false,
              targets: "no-sort"
            }]
          });

          $('#txt_partidas').on( 'keyup', function () {
            tbl_partidas.search( this.value ).draw();
          });
        });
        /*setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);*/
        this.readAnexos('ADQUISICION',anio,idProcedimiento);

      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  getProveedor(): Proveedor {
    let prov: Proveedor
    prov = this.apiAuth.getTokenDecoded();

    if (isNullOrUndefined(prov)) {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
      return null;
    } else {
      return prov;
    }
  }

  initPartidas(proveedor: string, valor?: any): FormGroup {
    return this.formBuilder.group({
      "partida_id":       [valor.PK_PARTIDA],
      "cantidad":         [valor.CANTSOL],
      "descripcion":      [valor.UNIDADMEDIDA],
      "desc_solicitada":  [valor.ARTICULOSOL],
      "anexo_tecnico":    [valor.ANEXOTECNICO],
      "folio_godocs":     [valor.FOLIOGODOCS],

      "anio":             this.anio,
      "proc_id":          this.idProc,
      "PK_Articulo":      [valor.PK_ARTICULO],
      "proveedor":        proveedor,

      "FKDPPPR_PK_CONSEC":[valor.FKDPPPR_PK_CONSEC],
      "desc_ofertada":    [valor.DESCOFERTADA, Validators.required],
      "precio_unit":      [valor.PRECIOUNITARIO, Validators.required],
      "tiempo_entrega":   [valor.TIEMPOENTREGA, Validators.required],
      "garantia":         [valor.GARANTIA, Validators.required],

      "movimiento":       'U',
      "isShow":           [valor.FKDPPPR_PK_CONSEC]   //campo de control para deteriminar si el row existe y hacerlo visible
    });
  }

  showFields(show: string, id: number, movto) {
    //let elem: NodeListOf<HTMLElement> = document.getElementsByName("ctrl_" + id);
    let btnPlus: HTMLElement = document.getElementById("btn_plus_" + id);
    let btnMinus: HTMLElement = document.getElementById("btn_minus_" + id);

    btnPlus.classList.toggle('d-none');
    btnMinus.classList.toggle('d-none');

    //this.frmPartidas.controls['partidasDetails'].get('state').reset();
    //this.frmPartidas.controls['partidasDetails'].get('state').disable();
    const field = (<FormGroup>this.frmPartidas.controls['partidasDetails']);

    /*Deshabilita o habilita los campos ocultos para que no entren en las validaciones de captura*/
    if (show == ''){
      field.controls[id].get('desc_ofertada').disable();
      field.controls[id].get('precio_unit').disable();
      field.controls[id].get('tiempo_entrega').disable();
      field.controls[id].get('garantia').disable();

      this.countPartipa = this.countPartipa - 1;
    }
    else {
      field.controls[id].get('desc_ofertada').enable();
      field.controls[id].get('precio_unit').enable();
      field.controls[id].get('tiempo_entrega').enable();
      field.controls[id].get('garantia').enable();

      this.countPartipa = this.countPartipa + 1;
    }

    /*vuelve visible o invisible los campos*/
    field.controls[id].patchValue({isShow: show});

    /*Asigna tipo de movimiento a realizar U: actualiza o D: eliminar*/
    field.controls[id].patchValue({movimiento: movto})
  }

  enviar() {
    let partidasUpdate: any[] = [];

    if (!this.validaFechaFin()) {
      //$('#texto_error').text('No puedes participar debido a que el tiempo de publicación a terminado.');
      this.mensajeError = 'No puedes participar debido a que el tiempo de publicación a terminado.';
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);

      return;
    }

    /*Activa la clase is-invalid para que en caso de ser invalido resalten los campos*/
    this.validaEnvio = true;

    /*Revisa que las validaciones de captura esten ok.*/
    if ($('#txt_fecha_cotiza').val() == '') {
      this.errfechaCotiza = true;
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#p_alerta').text('Para continuar es necesario capturar la fecha de vigencia de la cotización. Esta información aplica para todas las partidas en las que participe.');
        $('#mod_alerta').modal('show');
      }, 500);

      return;
    }

    this.errfechaCotiza = false;

    /*Revisa que la fecha de cotización no este vacía.*/
    if (this.frmPartidas.invalid) {
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#p_alerta').text('Para continuar es necesario que capture toda la información requerida de las partidas en las que participe o si lo prefiere elimine su participación.');
        $('#mod_alerta').modal('show');
      }, 500);

      return;
    }


    for (let i =0; i<this.anexos.length; i++) {
      //Si el documento es oblitario y no esta cargado, mostrara mensaje de alerta
      if (this.anexos[i].OBLIGATORIO === '1') {
        if (this.anexos[i].DOCCARGADO === '') {
          this.validaEnvio = false;
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#p_alerta').text('Documentos obligatorios sin cargar. Revise su paticipación.');
            $('#mod_alerta').modal('show');
          }, 500);

          return;
        }

      }
    }

    this.validaEnvio = false;

    /*Obtiene partidas a enviar*/
    let i=0;
    this.frmPartidas.controls['partidasDetails'].value.forEach(partida => {
      const field = (<FormGroup>this.frmPartidas.controls['partidasDetails']);

      /*Partidas eliminadas y que existían anteriormente en BD -que tienen un ID-*/
      if (partida.movimiento == 'D' && partida.FKDPPPR_PK_CONSEC !== ''){
        partidasUpdate.push(partida);
      }

      /*Partidas agregadas o actualizadas que esten visibles y que sus valores fueron cambiados.*/
      if (partida.movimiento == 'U' && partida.isShow !== '') { // && field.controls[i].touched){
        partidasUpdate.push(partida);
      }

      i++;
    });

    /*Registra partidas.*/
    if (partidasUpdate.length > 0) {
      this.apiProcedimientos.updateArticulosProv(partidasUpdate, $('#txt_fecha_cotiza').val()).subscribe(data => {
        if (data[0].success) {
          this.updatePartidasView();
          //this.frmPartidas.controls['partidasDetails'].get('state').reset();
          //this.frmPartidas.controls['partidasDetails'].get('state').disable();

          setTimeout(() => {
            $('#h_exito').text('La(s) propuesta(s) ha(n) sido almacenada(s), podrá seguir haciendo modificaciones mientras el procedimiento continue abierto.');
            $('#mod_procesando').modal('hide');
            $('#mod_exito').modal('show');
          }, 500);
        } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout( () => {
            //$('#texto_error').text('Ocurrió un error al intentar cargar las partidas, por favor intente nuevamente.');
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
          },500);
        }
      },error => {
        this.error = error.status;
        if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
        } else  {
          this.mensajeError = 'Ocurrió un error al intentar cargar las partidas, por favor intente nuevamente.';
        }
        setTimeout( () => {
          //$('#texto_error').text('Ocurrió un error al intentar cargar las partidas, por favor intente nuevamente.');
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        },500);
      });
    }else{
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#p_alerta').text('No hay cambios realizados en ningúna partida.');
        $('#mod_alerta').modal('show');
      }, 500);
    }
    //console.log(partidasUpdate);
  }

  disabledFields(id) {
    /*Deshabilita los campos que al inicio se presentan ocultos.*/
    const field = (<FormGroup>this.frmPartidas.controls['partidasDetails']);

    if (field.controls[id].get('FKDPPPR_PK_CONSEC').value == ''){
      field.controls[id].get('desc_ofertada').disable();
      field.controls[id].get('precio_unit').disable();
      field.controls[id].get('tiempo_entrega').disable();
      field.controls[id].get('garantia').disable();
    }
  }

  cargarArchivo(files: FileList) {
    this.files = files;
  }

  guardarArchivo() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();

    /*Valida el tiempo restante*/
    if (!this.validaFechaFin()) {
      // $('#texto_error').text('No puedes participar debido a que el tiempo de publicación a terminado.');
      this.mensajeError = 'No puedes participar debido a que el tiempo de publicación a terminado.';
      setTimeout(() => {
        $('#upload').modal('hide');
        $('#error').modal('show');
      }, 500);

      this.clearFile();
      return;
    }

    if (this.files !== undefined && this.files.length > 0) {
      $('#mod_procesando').modal('show');

      this.apiUpload.postAnexoTecnico('U', this.KeysFiles.anio, this.KeysFiles.idProcedimiento, this.KeysFiles.idPartida, this.KeysFiles.idProveedor, null,
                                      this.files[0], '').subscribe(data => {
        if (data[0].success) {
          /*Actualiza el nombre y ID del archivo en la vista.*/
          this.KeysFiles.nombre_file = this.files[0].name;
          this.KeysFiles.FolioGodocs = data[0].info;
          this.updateFilesView("U");
          this.clearFile();

          setTimeout( () => {
            $('#h_exito').text('¡El documento ha sido cargado exitosamente!');
            $('#mod_procesando').modal('hide');
            $('#mod_exito').modal('show');
          },500);
        } else {
          this.clearFile();
          this.mensajeError = data[0].msgRespuesta;
          setTimeout( () => {
            // $('#texto_error').text('Ocurrió un error al intentar cargar el archivo, por favor intente nuevamente.');
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
          },500);
        }
      },
      error => {
        this.clearFile();
        this.error = error.status;
        if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
        } else  {
          this.mensajeError = '¡Error!';
        }
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      });
    } else {
      $('#p_alerta').text('¡No se ha seleccionado ningún archivo!');
      $('#mod_alerta').modal('show');
    }
  }

  clearFile() {
    this.myInputFile.nativeElement.value = '';
  }

  saveKeysFiles(anio: string, idProcedimiento: string, idPartida: string, idProveedor: string, idRow: number, FolioGodocs: string, nombre_file: string) {
    this.KeysFiles = {
      idRow:          idRow,
      anio:           anio,
      idProcedimiento: idProcedimiento,
      idPartida:     idPartida,
      idProveedor:    idProveedor,
      FolioGodocs:    FolioGodocs,
      nombre_file:    nombre_file
    }
  }

  updatePartidasView() {
    let i=0;

    this.frmPartidas.controls['partidasDetails'].value.forEach(partida => {
      const field = (<FormGroup>this.frmPartidas.controls['partidasDetails']);

      /*Elimina los valores de la vista de partidas borradas ('D')*/
      if (partida.movimiento == 'D'){
        field.controls[i].patchValue({desc_ofertada: ''});
        field.controls[i].patchValue({precio_unit: ''});
        field.controls[i].patchValue({tiempo_entrega: ''});
        field.controls[i].patchValue({garantia: ''});
        field.controls[i].patchValue({anexo_tecnico: ''});
        field.controls[i].patchValue({FKDPPPR_PK_CONSEC: ''});
        field.controls[i].patchValue({folio_godocs: ''});
      }

      /*Actualiza un valor a las partidas agregadas o actualizadas y que esten visibles ('U').*/
      if (partida.movimiento == 'U' && partida.isShow !== '' && field.controls[i].touched){
        field.controls[i].patchValue({FKDPPPR_PK_CONSEC: 'Updated'});
      }

      i++;
    });
  }

  validaFechaFin() {
    /*Si la fecha de publicación terminó o es nula regresa False"*/
    let fechaActual = new Date();
    let fechaFinPub = new Date(this.datosGrales[0].FECFINPUB);

    if (isNaN(fechaFinPub.getTime()) || fechaFinPub.getTime() < fechaActual.getTime()){
      return false;
    }else{
      return true;
    }
  }

  eliminarArchivo() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();

    /*Valida el tiempo restante*/
    if (!this.validaFechaFin()) {
      // $('#texto_error').text('No puedes participar debido a que el tiempo de publicación a terminado.');
      this.mensajeError = 'No puedes participar debido a que el tiempo de publicación a terminado.';
      setTimeout(() => {
        $('#upload').modal('hide');
        $('#error').modal('show');
      }, 500);

      this.clearFile();
      return;
    }

    $('#mod_procesando').modal('show');
    this.apiUpload.postAnexoTecnico('D', this.KeysFiles.anio, this.KeysFiles.idProcedimiento, this.KeysFiles.idPartida, this.KeysFiles.idProveedor,
                                    this.KeysFiles.FolioGodocs, null, '').subscribe(data => {
      if (data[0].success) {
        /*Actualiza el nombre del archivo en la vista para eliminarlo.*/
        this.updateFilesView('D');

        setTimeout( () => {
          $('#h_exito').text('¡El documento ha sido eliminado exitosamente!');
          $('#mod_procesando').modal('hide');
          $('#mod_exito').modal('show');
        },500);
      } else {
        this.mensajeError = data[0].msgRespuesta;
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

  updateFilesView(movimiento: string) {
    let i=0;
    const field = (<FormGroup>this.frmPartidas.controls['partidasDetails']);

    /*Elimina los valores de la vista de partidas borradas ('D')*/
    if (movimiento == 'D'){
      field.controls[this.KeysFiles.idRow].patchValue({anexo_tecnico: ''});
      field.controls[this.KeysFiles.idRow].patchValue({folio_godocs: ''});
    }

    /*Actualiza un valor a las partidas agregadas o actualizadas y que esten visibles ('U').*/
    if (movimiento == 'U'){
      field.controls[this.KeysFiles.idRow].patchValue({anexo_tecnico: this.KeysFiles.nombre_file});
      field.controls[this.KeysFiles.idRow].patchValue({folio_godocs: this.KeysFiles.FolioGodocs});
    }
  }

  downloadFile(id: string, nombre: string) {
    this.apiDownload.downloadFile(id).subscribe(result => {
      var url = window.URL.createObjectURL(result);

      const link = this.downloadLink.nativeElement;
      link.href = url;
      link.download = nombre;
      link.click();

      window.URL.revokeObjectURL(url);
    });
  }

  cerrarSesion() {
    this.apiAuth.deleteToken();
    this.router.navigate(['/']).then(() => window.location.reload());
  }

  soloLetras(e) {
      let tecla = (document.all) ? e.keyCode : e.which;
      if (tecla==8) return true;
      let patron =/[A-Za-z0-9ñÑ\s.,]/;
      let te = String.fromCharCode(tecla);
      return patron.test(te);
  }

  readAnexos(iActido: string, anio: string, idProcedimiento: string) {
    //this.apiProcedimientos.getAnexos(iActido, anio, idProcedimiento).subscribe(data => {
    this.apiProcedimientos.getInfoObra(iActido,anio, idProcedimiento,'2',this.datosGrales[0].PROC_CONSEC).subscribe(data => {
      if(data[0].success){
        this.anexos = JSON.parse(data[0].info);
        console.log("Anexos", this.anexos);

        /*Si la tabla ya fue inicializa se destruye*/
        if ($.fn.dataTable.isDataTable('#tbl_anexos')) {
          $('#tbl_anexos').DataTable().destroy();
        }

        $(document).ready(function () {
          let tbl_anexos = $('#tbl_anexos').DataTable({
            /*dom: "<'row'<'col-sm-12 col-md-6'l>>" +
                  "<'row'<'col-sm-12'tr>>" +
                  "<'row'<'col-sm-12 col-md-6'><'col-sm-12 col-md-6'p>>",*/
             //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ]
          });

          $('#txt_anexos').on( 'keyup', function () {
            tbl_anexos.search( this.value ).draw();
          });
        })
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);

      } else {
        this.mensajeError = data[0].msgRespuesta;
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  download(cve_docto: string) {
    this.apiDownload.downloadFile(cve_docto);
  }


  reemplazaCaracter(evento) {
    let cadena = evento.target.value;
    cadena = cadena.replace(/["/\\]/g, '');
    cadena = cadena.replace(/[&\\]/g, ' and ');
    evento.target.value = cadena;
    this.comentarios = cadena;
  }

  //Guardar archivo
  guardarArchivoProc() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    if (this.files !== undefined && this.files.length > 0) {
        $('#mod_procesando').modal('show');
        this.apiUpload.postFileObraProcProv(proveedor.Correo,this.vpnMov,this.anio, this.idProc
          ,this.datosGrales[0].PROC_CONSEC,this.vpsTipoProv,this.vpsCveDoc,this.vpnGoddocs,this.comentarios,this.files[0]).subscribe(data => {
          if (data[0].success) {
            this.tipoMov = 0;
            setTimeout( () => {
              //this.mensajeExito = '¡El documento ha sido cargado correctamente!';
              $('#h_exito').text('¡El documento ha sido cargado exitosamente!');
              $('#mod_procesando').modal('hide');
              $('#mod_exito').modal('show');

              this.readAnexos('ADQUISICION',this.anio,this.idProc);
            },500);
          } else {
            this.mensajeError = data[0].msgRespuesta;
            setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
           }, 500);
          }
        },
        error => {
          this.error = error.status;
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        });
  } else {
    $('#info').modal('show');
  }
  }

  eliminarArchivoProc() {
    let proveedor: Proveedor;
    proveedor = this.apiAuth.getTokenDecoded();
    $('#mod_procesando').modal('show');
    this.apiUpload.deleteFileObraProcProv(proveedor.Correo, this.vpnMov, this.anio, this.idProc, this.datosGrales[0].PROC_CONSEC,this.vpsTipoProv,this.vpsCveDoc,this.vpnGoddocs).subscribe(data => {
      if (data[0].success) {
        this.tipoMov = 0;
        setTimeout( () => {
          this.mensajeExito = '¡El documento ha sido eliminado correctamente!';
          $('#h_exito').text('¡El documento ha sido eliminado exitosamente!');
          $('#mod_procesando').modal('hide');
          $('#mod_exito').modal('show');
          this.readAnexos('ADQUISICION',this.anio,this.idProc);
        },500);
      } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
              $('#mod_procesando').modal('hide');
              $('#error').modal('show');
           }, 500);
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
     }, 500);
    });
  }

 //Asigna los valores a las variables correspondientes, para realizar guardado o eliminado de archivos.
 arch(mov: string, cvedoc: string, goddocs: string, tipodocto: string) {
  this.myInput.nativeElement.value = ''; //Limpia el input file
  this.comentarios = '', //Limpia los comentarios
  this.vpnMov = mov;
  this.vpsCveDoc = cvedoc;
  this.vpnGoddocs = goddocs;
  this.vpsTipoProv = tipodocto;
  this.mensajeAlerta = '¿Estás seguro que desea eliminar el documento?';
  this.tipoAlerta = 0;
}

}
